import React, {useState} from "react";
import ReactFlow, {Background, Controls, addEdge, removeElements} from 'react-flow-renderer';

/** Вписывает схему в контейнер: без этого она открывается «в упор». */
export const fitFlowView = (reactFlowInstance) => {
    // без этого на телефоне схема открывается «в упор» и её приходится искать руками
    reactFlowInstance.fitView({padding: 0.1});
};

export const OverviewFlow = ({initialElements}) => {
    const [elements, setElements] = useState(initialElements);

    const onElementsRemove = (elementsToRemove) =>
        setElements((els) => removeElements(elementsToRemove, els));
    const onConnect = (params) => setElements((els) => addEdge(params, els));

    return (
        <ReactFlow
            elements={elements}
            onElementsRemove={onElementsRemove}
            onConnect={onConnect}
            onLoad={fitFlowView}
            snapToGrid={true}
            snapGrid={[15, 15]}
            style={{height: "100%"}}

        >
            <Controls />
            <Background color="#aaa" gap={16} />
        </ReactFlow>
    );
};



export default OverviewFlow
